import React from 'react';
import { Switch } from 'react-router-dom';

import SociosDeNegocio from './SociosDeNegocio';
import GuardianRoute from '../../shared/GuardianRoute';
import SociosDeNegocioInfo from './SociosDeNegocioInfo';
import SociosDeNegocioUpsert from './SociosDeNegocioUpsert';

const SociosDeNegocioRoutes = () => {
  return (
    <Switch>
      <GuardianRoute path="/modulos/socios"
        component={ SociosDeNegocio }
        can="socios.negocio.listar"
        exact
      />
      <GuardianRoute path="/modulos/socios/registrar"
        component={ SociosDeNegocioUpsert }
        can="socios.negocio.crear"
        exact
      />
      <GuardianRoute path="/modulos/socios/:id/info"
        component={ SociosDeNegocioInfo }
        can="socios.negocio.info"
        exact
      />
      <GuardianRoute path="/modulos/socios/:id/editar"
        component={ SociosDeNegocioUpsert }
        can="socios.negocio.editar"
        exact
      />
    </Switch>
  )

}

export default SociosDeNegocioRoutes;